<ion-content>
  <div class="modal-content">
    <div class="form-container">
      <form class="custom-form" #form="ngForm" #formElement (ngSubmit)="onSubmit(formElement)" [formGroup]="contactForm">
        <ion-list class="custom-form-wrapper">
          <ion-item class="custom-form-item">
            <ion-label class="custom-form-item-label" position="stacked"
              >{{ "FIELDS.NAME" | translate }} {{ optionalText }}
              <ion-icon
                class="custom-form-item-icon error-icon"
                src="/assets/custom-icons/b-times-circle.svg"
                *ngIf="contactForm.controls.name.errors && (contactForm.controls.name.touched || submitAttempt)"
              ></ion-icon
            ></ion-label>
            <ion-input class="custom-form-item-input" formControlName="name" type="text" aria-label=""></ion-input>
          </ion-item>

          <ion-item class="custom-form-item">
            <ion-label class="custom-form-item-label" position="stacked"
              >{{ "FIELDS.EMAIL" | translate }} {{ optionalText }}
              <ion-icon
                class="custom-form-item-icon error-icon"
                src="/assets/custom-icons/b-times-circle.svg"
                *ngIf="contactForm.controls.email.errors && (contactForm.controls.email.touched || submitAttempt)"
              ></ion-icon
            ></ion-label>
            <ion-input class="custom-form-item-input" formControlName="email" type="email" aria-label=""></ion-input>
          </ion-item>

          <ion-item class="custom-form-item">
            <ion-label class="custom-form-item-label" position="stacked"
              >{{ "FIELDS.PHONE" | translate }} {{ optionalText }}
              <ion-icon
                class="custom-form-item-icon error-icon"
                src="/assets/custom-icons/b-times-circle.svg"
                *ngIf="contactForm.controls.phoneNumber.errors && (contactForm.controls.phoneNumber.touched || submitAttempt)"
              ></ion-icon
            ></ion-label>
            <ion-input class="custom-form-item-input" formControlName="phoneNumber" type="tel" aria-label=""></ion-input>
          </ion-item>

          <ion-item class="custom-form-item">
            <ion-label class="custom-form-item-label" position="stacked"
              >{{ "FIELDS.COMMENTS_ENQUIRIES" | translate }}
              <ion-icon
                class="custom-form-item-icon error-icon"
                src="/assets/custom-icons/b-times-circle.svg"
                *ngIf="contactForm.controls.comments.errors && (contactForm.controls.comments.touched || submitAttempt)"
              ></ion-icon
            ></ion-label>
            <ion-textarea class="custom-form-item-textarea" formControlName="comments" rows="3" aria-label=""></ion-textarea>
          </ion-item>
        </ion-list>
      </form>
    </div>

    <div class="footer">
      <ion-row>
        <ion-col class="ion-no-padding">
          <ion-button expand="block" (click)="onDismiss()" color="grey" class="custom-button">{{ "CANCEL" | translate }}</ion-button>
        </ion-col>
        <ion-col class="ion-no-padding">
          <ion-button expand="block" (click)="form.ngSubmit.emit($event)" color="green" class="custom-button">
            {{ "SUBMIT" | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
